import "slick-carousel";

const $mainSlider = $(".js-mainSlider");

$mainSlider.find(".mainSlider_container").slick({
  appendDots: $mainSlider.find(".mainSlider_pagination"),
  autoplay: true,
  autoplaySpeed: 5000,
  centerMode: true,
  dots: true,
  nextArrow: '<button class="c-ico -arrowBlk -next"></button>',
  prevArrow: '<button class="c-ico -arrowBlk -prev"></button>',
  rows: 0,
  touchThreshold: 100,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 1120,
      settings: {
        appendArrows: $mainSlider.find(".mainSlider_pagination")
      }
    }
  ]
});

const $logoSlider = $(".js-logoSlider");

$logoSlider.find(".logoSlider_container").slick({
  autoplay: true,
  autoplaySpeed: 0,
  speed: 8000,
  cssEase: 'linear',
  centerMode: true,
  centerPadding: "20%",
  variableWidth: true,
  dots: false,
  arrows: false,
  swipe: false,
  pauseOnFocus: false,
  pauseOnHover: false,
  rows: 0,
  touchThreshold: 100,
  responsive: [
    {
      breakpoint: 1120
    }
  ]
});
